import consola from 'consola'

/**
 * Плагин для мониторинга истечения токенов в реальном времени
 *
 * Отслеживает:
 * - Когда токен истечет
 * - Предупреждает за 1 минуту до истечения
 * - Логирует все попытки обновления
 */

export default defineNuxtPlugin(() => {
  if (!process.client) return

  let monitorInterval: ReturnType<typeof setInterval> | null = null
  let lastWarningTime = 0
  const WARNING_COOLDOWN = 60_000 // Предупреждать не чаще раза в минуту
  const logger = consola.withTag('token-expiry-monitor')

  const startMonitoring = () => {
    // Проверяем каждые 10 секунд
    monitorInterval = setInterval(async () => {
      try {
        const { useSessionManager } = await import('~/entities/auth')
        const sessionManager = useSessionManager()

        // Получаем оставшееся время
        const remainingSeconds = sessionManager.getTokenRemainingTime()

        // Если бесконечность - токен не установлен
        if (remainingSeconds === Infinity) {
          return
        }

        // ✅ ИСПРАВЛЕНО: Проверяем, что пользователь авторизован
        // Если не авторизован - не показываем ошибки об истечении токена
        if (!sessionManager.hasActiveSession.value) {
          return
        }

        const now = Date.now()

        // Предупреждение за 1 минуту до истечения
        if (remainingSeconds <= 60 && remainingSeconds > 0 && now - lastWarningTime > WARNING_COOLDOWN) {
          lastWarningTime = now
          logger.warn('⚠️ Token expires in less than a minute', {
            remainingSeconds: Math.floor(remainingSeconds),
          })
        }

        // Токен истек
        if (remainingSeconds <= 0) {
          logger.error('🔴 Token expired', {
            remainingSeconds,
          })
        }

      } catch (error) {
        logger.error('Ошибка мониторинга токена', error)
      }
    }, 10_000) // Каждые 10 секунд
  }

  const stopMonitoring = () => {
    if (monitorInterval) {
      clearInterval(monitorInterval)
      monitorInterval = null
    }
  }

  // Запускаем мониторинг
  startMonitoring()

  // Останавливаем при размонтировании
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', stopMonitoring)
  }

  return {
    provide: {
      tokenExpiryMonitor: {
        start: startMonitoring,
        stop: stopMonitoring,
      },
    },
  }
})


